import SimilarListing from 'components/elements/similarListing';
import { NewGListingContent } from 'lib/apis/services/PlpListing/type';

interface Props {
  data: NewGListingContent[] | undefined;
  isLoading: boolean;
  isError: boolean;
  isFetched: boolean;
}

function PdpSimilarListing({ data, isLoading, isError, isFetched }: Props) {
  // console.log('log', data, isLoading, isError, isFetched)
  return (
    <SimilarListing
      content={data}
      isLoading={isLoading}
      isError={isError}
      isFetched={isFetched}
    />
  );
}

export default PdpSimilarListing;
